// src/components/store/sections/gallery/GalleryV85CathedralwindowsEmeraldMint.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV85CathedralwindowsEmeraldMint(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={85}
      archKey="cathedral_windows"
      archLabel="Cathedral Arch Windows"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
